import shop from "../shop";

class RobloxProducts extends HTMLElement {
    constructor() {
        super();
        this.slider = $(this.querySelector('.js-roblox-products'));
        console.log( this.slider)

        if (this.slider.length>0) {
            this.slider.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                adaptiveHeight: false,
                prevArrow:'<button type="button" class="slick-prev"><svg width="90" height="91" viewBox="0 0 90 91" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<g filter="url(#filter0_d_3_8322)">' +
                    '<circle cx="25" cy="25" r="25" transform="matrix(-1 0 0 1 70 20.3433)" fill="#0047BB"/>' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M31.1496 46.1926C31.3118 45.9496 36.3628 41.0974 41.8129 37.3433C42.8167 38.0516 43.5168 39.0729 43.8848 40.0361C41.2706 41.6672 38.354 43.1309 35.7691 44.8498C44.5024 44.1193 48.106 44.3237 57.9909 44.8585L58.5218 44.901L58.7593 45.4258C58.9643 45.8787 59.0406 46.3703 58.9795 46.8481C58.9281 47.255 58.7807 47.6387 58.5418 47.9872L58.227 48.4463L57.7078 48.3921C50.4813 47.7031 45.8014 47.496 36.1398 47.6892C38.967 49.1492 41.7359 50.2607 44.6729 51.4707C44.3608 52.4536 43.9117 53.5782 42.95 54.3433C38.9142 52.7097 32.5183 48.9981 31.1423 46.8757C30.9942 46.6476 30.9121 46.4315 31.1496 46.1926Z" fill="#F2E9DB"/>' +
                    '</g>' +
                    '<defs>' +
                    '<filter id="filter0_d_3_8322" x="0" y="0.343262" width="90" height="90" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
                    '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
                    '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
                    '<feOffset/>' +
                    '<feGaussianBlur stdDeviation="10"/>' +
                    '<feComposite in2="hardAlpha" operator="out"/>' +
                    '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>' +
                    '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_8322"/>' +
                    '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_8322" result="shape"/>' +
                    '</filter>' +
                    '</defs>' +
                    '</svg></button>',
                nextArrow:'<button type="button" class="slick-next"><svg width="90" height="91" viewBox="0 0 90 91" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<g filter="url(#filter0_d_3_8319)">' +
                    '<circle cx="45" cy="45.3433" r="25" fill="#0047BB"/>' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M58.8504 46.1926C58.6882 45.9496 53.6372 41.0974 48.1871 37.3433C47.1833 38.0516 46.4832 39.0729 46.1152 40.0361C48.7294 41.6672 51.646 43.1309 54.2309 44.8498C45.4976 44.1193 41.894 44.3237 32.0091 44.8585L31.4782 44.901L31.2407 45.4258C31.0357 45.8787 30.9594 46.3703 31.0205 46.8481C31.0719 47.255 31.2193 47.6387 31.4582 47.9872L31.773 48.4463L32.2922 48.3921C39.5187 47.7031 44.1986 47.496 53.8602 47.6892C51.033 49.1492 48.2641 50.2607 45.3271 51.4707C45.6392 52.4536 46.0883 53.5782 47.05 54.3433C51.0858 52.7097 57.4817 48.9981 58.8577 46.8757C59.0058 46.6476 59.0879 46.4315 58.8504 46.1926" fill="#F2E9DB"/>' +
                    '</g>' +
                    '<defs>' +
                    '<filter id="filter0_d_3_8319" x="0" y="0.343262" width="90" height="90" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
                    '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
                    '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
                    '<feOffset/>' +
                    '<feGaussianBlur stdDeviation="10"/>' +
                    '<feComposite in2="hardAlpha" operator="out"/>' +
                    '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>' +
                    '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_8319"/>' +
                    '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_8319" result="shape"/>' +
                    '</filter>' +
                    '</defs>' +
                    '</svg></button>',

                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    }


}
export default RobloxProducts;